import { useEffect, useState } from 'react';
import { CircularLoading } from 'respinner';
import { useHistory } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import Button from 'components/button';
import { CouponFillIcon, ChevronRightIcon } from '../components/icons';
import LoadingDialog from 'components/loading-dialog';
import { CouponList } from '../components/coupon-list';
import { EmptyState } from '../components/empty-state';
import styles from './coupon-page.module.sass';
import { useCoupons } from '../hooks/use-coupons';
import { COUPON_ITEM_CLASS_NAME } from '../constants';
import { PATH } from 'config';
import { ErrorMessage } from '../components/error-message';
import { registerInViewEvent } from "../../../helpers/register-inview-event";


export function CouponPage() {
  const history = useHistory();
  const navigate = history.push;
  const { coupons, next, status } = useCoupons({ state: ['available', 'not_started'] });

  useEffect(() => {
    const lastItem = document.querySelector(`.${COUPON_ITEM_CLASS_NAME}:last-child`)

    const unregister  = registerInViewEvent(lastItem, next)

    return unregister;  
  }, [coupons, next]);

  if (status === 'fetching' && coupons.length === 0) return <LoadingDialog isShow/>;

  if (status === 'error') {
    return (
      <ErrorMessage
        type="failure"
        isShow
        autoDismiss={false}
        onDismiss={() => {
          window.location.reload();
        }}
      >
        有東西出錯了，請點擊以重新整理
      </ErrorMessage>
    );
  }

  const navigateToExchangePage = () => {
    navigate(PATH.COUPON_EXCHANGE);
  };
  const navigateToExpiredPage = () => {
    navigate(PATH.COUPON_EXPIRED);
  };

  



  return (
    <div className={styles.root}>
      <h3 className={styles.title}>序號兌換</h3>
      <Button variant="blue" onClick={navigateToExchangePage}>
        <CouponFillIcon className={styles.exchangeIcon} />
        序號兌換
      </Button>
      <div className={styles.header}>
        <p className={styles.headerTitle}>可使用優惠券</p>
        <Button theme="link" onClick={navigateToExpiredPage} className={styles.expired}>
          已失效 <ChevronRightIcon width={18} height={18} />
        </Button>
      </div>
      {isEmpty(coupons) ? <EmptyState content="無可使用優惠卷" /> : <CouponList coupons={coupons} type="available" />}
      {status === 'fetching' && <CircularLoading className={styles.loading} size={24} duration={1} />}

      
    </div>
  );
}
